import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import "./index.css";
import './i18n';
import generateMuiTheme from "./SdkSrc/mui/theme";
import { ThemeProvider } from "@material-ui/styles";
import "react-toastify/dist/ReactToastify.css";
import { I18nProvider } from './i18n';
import { NotificationProvider } from './notifications/NotificationContext';


ReactDOM.render(
  <>
    <ThemeProvider theme={generateMuiTheme()}>
        <I18nProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
        </I18nProvider>
    </ThemeProvider>
  </>,
  document.getElementById("root")
);

